module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/logo_ppa-ecb5fec98ab9deca3fb59d6d00473ce6.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/logo_ppa.png
// module id = 891
// module chunks = 2